/**
 * Returns whether the app is currently running in reduced-graphics mode.
 *
 * GraphicsQualityProvider also marks `<html data-reduced-graphics="true">`,
 * for any stylesheet that wants the signal. The Ledger's layers are opaque
 * and draw no blur (DEVIATIONS D-08), so nothing in the theme reads it any
 * more; the "Reduced graphics" setting keeps working with less to turn off.
 * This hook is for the consumer that needs the signal programmatically.
 *
 * Falls back to `false` (full graphics) when no provider is mounted, same
 * fallback shape as useNow().
 */
import { createContext, useContext } from "react";

export const GraphicsQualityContext = createContext<{
  reducedGraphics: boolean;
}>({ reducedGraphics: false });

export function useGraphicsQuality(): { reducedGraphics: boolean } {
  return useContext(GraphicsQualityContext);
}
